import React from 'react'
import { Trans, useTranslation } from 'next-i18next'
import {
  Box,
  IllustrationLocked,
  Inline,
  Stack,
  Text,
  TextLinkButton,
  useDialogControllers
} from '@machobear/design-system'

import DSLoginModal from '../Auth/login-modal/ds-login-modal'

const LoginRequiredCard = ({
  externalInfo
}: {
  externalInfo: { source_info_name: string }
  width?: string
}) => {
  const { t } = useTranslation()

  const source = externalInfo?.source_info_name
  const { visible, showModal, closeModal } = useDialogControllers({
    login: false,
    register: false
  })

  const handleShowModal = (mode: 'login' | 'register') => {
    showModal(mode)()
  }

  const eventId = '"web-signup-submit-login-redirect-mls"'

  return (
    <>
      <Box
        paddingX="large"
        paddingY={{ mobile: 'large', tablet: 'xlarge' }}
        background="white"
        borderRadius="xlarge"
        boxShadow="borderNeutralLight"
        width="full"
      >
        <Stack space={{ mobile: 'small', tablet: 'gutter' }} align="left">
          <Inline align="center" space="none">
            <IllustrationLocked />
          </Inline>
          <Text size="xlarge" weight="strong" align="center">
            {t('b.listing.login.required.card.title', 'Login Required')}
          </Text>
          <Text size="medium" tone="secondary">
            <Trans
              i18nKey="b.listing.login.required.card.description"
              values={{ source }}
              defaults="This listing contains information provided by {{ source }}."
            />
          </Text>
          <Trans i18nKey="b.listing.login.required.card.action.text" t={t}>
            <Text>
              Please{' '}
              <TextLinkButton
                weight="regular"
                id="listing_details_mls_loginrequired_login_click"
                onClick={() => handleShowModal('login')}
              >
                login
              </TextLinkButton>{' '}
              or{' '}
              <TextLinkButton
                weight="regular"
                id="listing_details_mls_loginrequired_signup_click"
                onClick={() => handleShowModal('register')}
              >
                sign up
              </TextLinkButton>{' '}
              to continue.
            </Text>
          </Trans>
        </Stack>
      </Box>
      <DSLoginModal
        t={t}
        mode="login"
        visible={visible.login}
        onClose={closeModal('login')}
        eventId={eventId}
      />
      <DSLoginModal
        t={t}
        mode="register"
        visible={visible.register}
        onClose={closeModal('register')}
        eventId={eventId}
      />
    </>
  )
}

export default LoginRequiredCard
